import { useQuery } from "@apollo/react-hooks"
import CircularProgress from "@material-ui/core/CircularProgress"
import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import gql from "graphql-tag"
import React, { useEffect } from "react"
import cnchar from "cnchar"
import { isArrowFunction } from "typescript"
import { array } from "prop-types"
const generateQuery = (tableName: string, whereQuery?: string) => {
    const isUserTable = tableName === "users" || tableName === "users_public"
    const index = isUserTable ? "uid" : "id"
    const name = isUserTable ? "nickname" : "name"
    let where = isUserTable ? ", where: {is_leader: {_eq: true}}" : ""
    if (whereQuery) {
        where = whereQuery
    }
    return gql`
        query {
            ${tableName}(order_by: {${name}: asc} ${where}) {
                ${index}
                ${name}
            }
        }
    `
}

const ITEM_HEIGHT = 48
interface ComponentProps {
    tableName: string,
    onChange: (value: any) => void,
    rowData?: any,
    // 优先使用staticValue 的数据
    staticValue?: string,
    staticValueList?: string[],
    whereQuery?: string
}
const FieldSelect = (props: ComponentProps) => {
    const { onChange, rowData, tableName, staticValue, staticValueList, whereQuery } = props
    const isUserTable = tableName === "users" || tableName === "users_public"
    const index = isUserTable ? "uid" : "id"
    const initId = rowData ? rowData[`${tableName}_${index}`] : ""
    const [ id, setId ] = React.useState(initId)
    const query = generateQuery(tableName, whereQuery)
    const { data, loading } = useQuery(query, {
        fetchPolicy: "network-only",
    }) || {}

    // 传入选项的值 兼容多选项
    // staticValue字符串值 优先
    // staticValueList 列表值
    const _staticValues = staticValue || staticValueList || null
    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        setId(event.target.value as number)
        onChange(event.target.value as number)
    }
    useEffect(() => {
        const initId = rowData ? rowData[`${tableName}_${index}`] : ""
        // eslint-disable-next-line
        initId && setId(initId)
    }, [rowData, tableName])
    useEffect(() => {
        if(rowData) return
        if(!(data && data[tableName])) return
        if(_staticValues) {
            const { id } = data[tableName].find(({ name }: any) => {
                if(Array.isArray(_staticValues) && _staticValues[0]) return name === _staticValues[0]
                return name === staticValue
            }) || {}
            // eslint-disable
            id && setId(id)
            // eslint-disable
            id && onChange(id)
        }
    }, [data])
    if (loading) { return <CircularProgress /> }
    const name = isUserTable ? "nickname" : "name"
    const sortFn = isUserTable ? (a: any, b: any) => {
        if (cnchar.isCnChar(a[name]) && cnchar.isCnChar(b[name])) {
            return cnchar.compareSpell(a[name], b[name]) === "more" ? 1 : -1
        } else {
            return 0
        }
    } : () => {}
    return (
        <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={id || ""}
            onChange={handleChange}
            MenuProps={{
                style: {
                    maxHeight: ITEM_HEIGHT * 10.5,
                    width: 200,
                },
            }}
        >
            {data[tableName].sort(sortFn).map((c: any) => {
                if (!(_staticValues && _staticValues.length)) return <MenuItem value={c[index]} key={c[index]}>{c[name]}</MenuItem>
                if (_staticValues && (
                    Array.isArray(_staticValues) && _staticValues.indexOf(c[name]) >= 0 ||
                    _staticValues === c[name]
                )) {
                    return <MenuItem value={c[index]} key={c[index]}>{c[name]}</MenuItem>
                }

                return null
            })}
        </Select>
    )
}

export default FieldSelect
